﻿export default function joinPath(...paths: (string | string[])[]): string {
    const pathsArray =
        paths.length === 1 && Array.isArray(paths[0]) ? paths[0] : paths;

    return (pathsArray as string[])
        .map((path) => path.replace(/(^\/|\/$)/g, ''))
        .filter((path) => path !== '')
        .join('/');
}
